import { Bar, Scatter, Line } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    PointElement,
    Title,
    Tooltip,
    Legend,
    LineElement
} from 'chart.js';
import { Card, Paper } from '@mui/material';

// Register components once for all charts
ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    PointElement,
    Title,
    Tooltip,
    Legend,
    LineElement
);


// BarGraph component
export const BarGraph = ({ data, options, title = 'Bar Chart', label = 'label' }) => {
    const defaultData = {
        labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'],
        datasets: [
            {
                label: label,
                data: [65, 59, 80, 81, 56, 55],
                backgroundColor: 'rgba(75,192,192,0.6)',
            },
        ],
    };

    const defaultOptions = {
        responsive: true,
        plugins: {
            legend: { position: 'top' },
            title: { display: true, text: title },
        },
    };

    return <Bar data={data || defaultData} options={options || defaultOptions} />;
};

// ScatterPlot component
// export const ScatterPlot = ({ data, options, title = "Scatter Plot", label = 'Scatter Dataset' }) => {
//     const defaultData = {
//         datasets: [
//             {
//                 label: label,
//                 data: [
//                     { x: 10, y: 20 },
//                     { x: 15, y: 10 },
//                     { x: 20, y: 30 },
//                     { x: 25, y: 15 },
//                     { x: 30, y: 25 },
//                 ],
//                 backgroundColor: 'rgba(255,99,132,0.8)',
//             },
//         ],
//     };

//     const defaultOptions = {
//         responsive: true,
//         scales: {
//             x: {
//                 type: 'linear',
//                 position: 'bottom',
//                 title: { display: true, text: 'X Axis' },
//             },
//             y: {
//                 title: { display: true, text: 'Y Axis' },
//             },
//         },
//         plugins: {
//             legend: { position: 'top' },
//             title: { display: true, text: title },
//         },
//     };

//     return <Scatter data={data || defaultData} options={options || defaultOptions} />;
// };






export const ScatterPlot = ({ data, title = "Scatter Plot", label = "Scatter Dataset" }) => {
    if (!data || !data.x || !data.predicted || !data.actual || !data.title) {
        return <div>Loading scatter plot...</div>;
    }

    const { x, predicted, actual, xLabel, yLabel } = data;

    const chartData = {
        datasets: [
            {
                label: "Prediction",
                data: x.map((xi, i) => ({ x: xi, y: predicted[i] })),
                backgroundColor: "rgba(0, 0, 255, 0.7)",
                pointRadius: 4
            },
            {
                label: "Actual",
                data: x.map((xi, i) => ({ x: xi, y: actual[i] })),
                backgroundColor: "rgba(0, 128, 0, 0.9)",
                pointRadius: 4
            }
        ]
    };

    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: "bottom",
                align: "center"
            },
            title: {
                display: true,
                text: title
            }
        },
        scales: {
            x: {
                title: {
                    display: true,
                    text: xLabel
                }
            },
            y: {
                title: {
                    display: true,
                    text: yLabel
                }
            }
        }
    };

    return <Scatter data={chartData} options={options} />;
};


export const ScatterPlotWithoutData = ({ data, label = "Scatter Dataset" }) => {
    if (!data || !data.residuals || !data.actual || !data.title) {
        return <div>Loading scatter plot...</div>;
    }

    const { actual, residuals, title } = data;

    const chartData = {
        datasets: [
            {
                label: "Residuals (MAPE %)",
                data: actual.map((x, i) => ({ x, y: residuals[i] })),
                backgroundColor: "rgba(255, 99, 132, 0.8)",
                pointRadius: 5
            }
        ]
    };

    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: "bottom",
                align: "center"
            },
            title: {
                display: true,
                text: title
            }
        },
        scales: {
            x: {
                title: {
                    display: true,
                    text: "Actual"
                },
                grid: {
                    color: "lightgray"
                }
            },
            y: {
                title: {
                    display: true,
                    text: "MAPE (%)"
                },
                grid: {
                    color: "lightgray"
                }
            }
        }
    };

    return <Scatter data={chartData} options={options} />;
};








// export const LineChart = ({ data, options, title = 'Line Chart Example' }) => {

//     const defaultData = {
//         labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May'],
//         datasets: [
//             {
//                 label: 'Sample Data',
//                 data: [10, 20, 15, 30, 31],
//                 borderColor: 'rgba(75,192,192,1)',
//                 backgroundColor: 'rgba(75,192,192,0.2)',
//                 tension: 0.3, // smooth curve
//                 pointRadius: 5,
//                 pointBackgroundColor: '#007bff',
//                 fill: false,
//             },
//         ],
//     };

//     const defaultOptions = {
//         responsive: true,
//         plugins: {
//             legend: { position: 'top' },
//             title: { display: true, text: title },
//         },
//     };

//     return <Line data={data || defaultData} options={options || defaultOptions} />;
// };





export const MultiLineChart = ({ data, options, title = 'Line Chart' }) => {
    const defaultData = {
        labels: ['A', 'B', 'C', 'D', 'E'],
        datasets: [
            {
                label: 'Dataset 1',
                data: [12, 19, 3, 5, 2],
                borderColor: 'rgba(255,99,132,0.8)',
                backgroundColor: 'rgba(255,99,132,0.8)',
                tension: 0.3,
                pointRadius: 4,
                fill: false
            },
            {
                label: 'Dataset 2',
                data: [4, 8, 15, 16, 23],
                borderColor: 'rgba(212, 120, 14, 0.8)',
                backgroundColor: 'rgba(212, 120, 14, 0.8)',
                tension: 0.3,
                pointRadius: 4,
                fill: false
            },
            {
                label: 'Dataset 3',
                data: [20, 10, 25, 18, 7],
                borderColor: 'rgba(75,192,192,1)',
                backgroundColor: 'rgba(75,192,192,1)',
                tension: 0.3,
                pointRadius: 4,
                fill: false
            }
        ]
    };


    const defaultOptions = {
        responsive: true,
        plugins: {
            legend: {
                display: true,
            },
            title: {
                display: true,
                text: title,
                align: 'center',// optional: left | center | right
                font: {
                    size: 12,
                    weight: 'bold',
                },
                padding: {
                    top: 10,
                    bottom: 20,
                },
                color: 'rgb(18, 58, 58)',
            },
        },
        scales: {
            y: {
                beginAtZero: true,
            },
        },
    };

    return <Line data={data || defaultData} options={options || defaultOptions} />;
};



export const ErrorHistogram = ({ chartDataJson }) => {
    if (!chartDataJson || !chartDataJson.data) {
        return <div>Loading...</div>;
    }

    const { title, x_axis_label, y_axis_label, x_range, data } = chartDataJson;

    const chartData = {
        labels: data.map((item) => item.x.toFixed(2)),  // x-axis bin centers
        datasets: [
            {
                label: y_axis_label,
                data: data.map((item) => item.y),  // counts
                backgroundColor: 'rgba(153, 102, 255, 0.7)',
                borderColor: 'rgba(153, 102, 255, 1)',
                borderWidth: 1,
            }
        ]
    };

    const options = {
        responsive: true,
        plugins: {
            title: {
                display: true,
                text: title,
                font: { size: 18 },
            },
            legend: { display: false },
            tooltip: { mode: 'index', intersect: false },
        },
        scales: {
            x: {
                title: {
                    display: true,
                    text: x_axis_label,
                },
                ticks: {
                    autoSkip: true,
                    maxRotation: 90,
                    minRotation: 45
                }
            },
            y: {
                title: {
                    display: true,
                    text: y_axis_label,
                },
                beginAtZero: true,
            }
        }
    };

    return <Bar data={chartData} options={options} />;
};

